import RestUtility from '../../../restUtility';
import { notifyError } from 'config/setupBugsnag';
import {
  IdsStoreSettings,
  IdsStoreSettingsResponse,
  SaveIdsStoreSettingsPayload,
} from 'types/dso/DsoIdsStoreSettings.types';
import {
  dsoIdsStoreSettingsEndPoint,
  dsoIdsStoreSettingsUpdateEndPoint,
} from '../../../restUtility/restEndpoints';

export class DsoIdsStoreSettingsService {
  private readonly restUtility: RestUtility;

  constructor() {
    this.restUtility = new RestUtility();
  }

  async getIdsStoreSettings(): Promise<IdsStoreSettings> {
    try {
      const response = await this.restUtility.get<IdsStoreSettingsResponse>(
        dsoIdsStoreSettingsEndPoint
      );
      return this.buildSettings(response);
    } catch (error) {
      notifyError('ApiError:: DSO::getIdsStoreSettings', error);
      throw error;
    }
  }

  async saveIdsStoreSettings(
    payload: SaveIdsStoreSettingsPayload
  ): Promise<IdsStoreSettings> {
    try {
      const response = await this.restUtility.post<IdsStoreSettingsResponse>(
        dsoIdsStoreSettingsUpdateEndPoint,
        payload
      );

      return this.buildSettings(response);
    } catch (error) {
      notifyError('ApiError:: DSO::saveIdsStoreSettings', error);
      throw error;
    }
  }

  private buildSettings(response: IdsStoreSettingsResponse): IdsStoreSettings {
    return {
      accessMode: response.ids_access_mode,
      paymentMode: response.ids_payment_mode,
    };
  }
}
